// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox","498": "geo-vendor",}[chunkId] || chunkId) + "." + {"182": "076ef0e1a55bff43","396": "48058625a11b4cc0","460": "5c9a6985d44b2515","498": "226f7a1804557e4b","917": "5815ce6b3d813599","985": "f33cb1f65d8d7654",}[chunkId] + ".chunk.js"
}